import { useState } from "react";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import AuthModal from "./AuthModal";
import { api } from "../lib/api";
import { useAuth, authHeaders } from "../lib/auth";

/**
 * Buy button on service cards.
 * Shows a Sign-In modal first if the user is not authenticated,
 * then hits POST /api/checkout and redirects to Stripe.
 */
export default function BuyServiceButton({ service }) {
  const { token, ready } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const priceLabel = service.price != null && service.currency
    ? `${(service.currency || "").toUpperCase()} ${Number(service.price).toFixed(2)}`
    : null;
  const buyable = service.price != null && service.currency && service.active !== false;

  const startCheckout = async () => {
    setBusy(true);
    try {
      const t = localStorage.getItem("brep_token");
      const res = await api.post(
        "/checkout",
        { service_id: service.id, origin_url: window.location.origin },
        { headers: authHeaders(t) },
      );
      window.location.href = res.data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't start checkout.");
      setBusy(false);
    }
  };

  const onClick = () => {
    if (!buyable) return;
    if (!token) {
      setAuthOpen(true);
      return;
    }
    startCheckout();
  };

  if (!ready) return null;

  return (
    <>
      <button
        type="button"
        onClick={onClick}
        disabled={!buyable || busy}
        className={`btn-primary group inline-flex items-center gap-3 px-5 py-3 text-[11px] tracking-[0.22em] uppercase font-medium ${!buyable ? "opacity-50 cursor-not-allowed" : ""}`}
        data-testid={`buy-${service.slug}`}
        aria-disabled={!buyable}
      >
        {buyable ? (busy ? "…" : `Buy ${priceLabel ? "· " + priceLabel : ""}`) : "Book in the app"}
        <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
      <AuthModal
        open={authOpen}
        onClose={() => setAuthOpen(false)}
        onAuthed={() => setTimeout(startCheckout, 60)}
        initialMode="signup"
      />
    </>
  );
}
